<template>
  <main class="system-communications">
    <section class="system-communications-main-section">
      <system-communications-email-item
        type="welcome"
        @click="viewEmail('welcome')"
      />
      <system-communications-email-item
        type="password-recovery"
        @click="viewEmail('password-recovery')"
      />
    </section>
  </main>
</template>
<script>
import SystemCommunicationsEmailItem from "@components/modules/system-communications/email/item/SystemCommunicationsEmailItem";

export default {
  components: { SystemCommunicationsEmailItem },

  data() {
    return {};
  },

  methods: {
    viewEmail(type) {
      this.$router.push({
        path: `/system-communications/email/${type}`,
      });
    },
  },

  mounted() {},
};
</script>
<style lang="scss" scoped>
.system-communications {
  display: flex;
  justify-content: center;
  padding-top: 60px;

  .system-communications-main-section {
    display: inherit;
    gap: 50px;
  }
}
</style>
